<div class="dialog-header app-game-dialog-mix-table-details-header">
    <div class="dialog-header-close-button">
        <button (click)="close()">
            <svg-icon src="assets/img/icons/dialog-close.svg"
                [stretch]="true"
                [applyClass]="true"
                class="dialog-header-close-button-icon" />
        </button>
    </div>
</div>

<div class="app-game-dialog-mix-table-details-content">
  <div
    *ngIf="table.mixTableDetails"
    class="app-game-dialog-mix-table-details-content-rotate-info"
  >
    {{ 'game.mixTable.rotateEvery' | translate }} {{ table.mixTableDetails.rotateEvery }}
    <span *ngIf="table.mixTableDetails.rotateEvery > 1; else hand">{{ 'game.mixTable.hands' | translate }}</span>
    <ng-template #hand>{{ 'game.mixTable.hand' | translate }}</ng-template>
  </div>
  <table>
    <thead>
      <tr>
        <th class="position">#</th>
        <th class="variant">{{ 'game.mixTable.headers.variant' | translate }}</th>
        <th class="limit">{{ 'game.mixTable.headers.limit' | translate }}</th>
        <th class="blinds">{{ 'game.mixTable.headers.blinds' | translate }}</th>
        <th class="ante">{{ 'game.mixTable.headers.ante' | translate }}</th>
        <th class="bring-in">{{ 'game.mixTable.headers.bringIn' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let table of table.mixTableDetails?.tables; let i = index">
        <td class="position">{{ i + 1 }}</td>
        <td class="variant">
          {{
            "common.variant.lobby." + VariantType2[table.variant] | translate
          }}<span *ngIf="table.optionDoubleBoard">, DB</span>
        </td>
        <td class="limit">{{ table.game.limit }}</td>
        <td class="blinds">
          {{ table.blind | gcy : selectedCurrency }} /
          {{ table.blind * 2 | gcy : selectedCurrency }}
        </td>
        <td class="ante">{{ table.ante | gcy : selectedCurrency }}</td>
        <td class="bring-in">{{ table.bringIn | gcy : selectedCurrency }}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="app-game-dialog-mix-table-details-footer">
  <button appButton (click)="close()">Ok</button>
</div>
